.loaderContainer {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 9;
  border-radius: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
}
